var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crown-button',_vm._g({attrs:{"id":"lane-below-button","aria-label":"Add lane below icon","width":25}},_vm.$listeners),[_c('font-awesome-icon',{attrs:{"icon":['fpm', 'fa-lane-below']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }